ulekareApp.factory('T', function(C){

	var translations = {
		'cs': {
			'ulekare.web.form': {
				'validation': {
					'question': {
						'missing': 'text otázky',
						'notBlank': 'Dotaz na lékaře je povinný, prosím, vyplňte ho.'
					},
					'problem' : {
						'missing': 'text problému',
						'notBlank': 'Problém je povinný, prosím, vyplňte ho.'
					},
					'firstName' : {
						'missing': 'jméno',
						'notBlank': 'Jméno je povinné, prosím, vyplňte ho.'
					},
					'lastName' : {
						'missing': 'příjmení',
						'notBlank': 'Příjmení je povinné, prosím, vyplňte ho.'
					},
					'email' : {
						'missing': 'e-mail',
						'notBlank': 'E-mail je povinný, prosím, vyplňte ho.',
						'email': 'E-mail nemá správný formát.'
					},
					'birthYear' : {
						'missing': 'rok narození',
						'notBlank': 'Rok narození je povinný, prosím, vyplňte ho.',
						'regexp': 'Rok narození napište v čtyřčíselném formátu.',
						'range': 'Napište skutečný rok narození.'
					},
					'phone' : {
						'missing': 'telefon',
						'notBlank': 'Telefon je povinný, prosím, vyplňte ho.',
						'regexp': 'Zadejte telefonní číslo (+420 123456789).',
						'phoneNumber': 'Zadejte telefonní číslo (+420 123456789).'
					},
					'zipCode' : {
						'missing': 'PSČ',
						'notBlank': 'PSČ je povinné, prosím, vyplňte ho.',
						'regexp': 'PSČ nemá správný formát.'
					},
					'personalDataAgreement' : {
						'missing': 'souhlas se zpracováním osobních údajů',
						'true': 'Musíte souhlasit se zpracováním osobních údajů.'
					},
					'tariffVariant' : {
						'missing': 'možnost využití služby zdarma',
						'true': 'Musíte vybrat možnost využití služby zdarma.'
					},
					'employeeEmail' : {
						'email': 'E-mail nemá správný formát.',
						'invalid': 'Neplatný e-mail pro využití benefitu.',
						'benefitBlocked': 'Nárok na benefit vypršel, kontaktujte svého HR.',
						'sameAsPersonal': 'Zadejte pracovní e-mail.'
					},
					'benefitCode' : {
						'regexp': 'Neplatný kód',
						'useCompanyEmail': 'Platnost kódu vypršela, zadejte firemní email.',
						'length': 'Kód má délku 6 znaků.'
					}
				},
				'loadingMessage': 'Načítám...',
				'offlineMessage': 'Momentálně jste bez připojení k internetu.',
				'missing.and': 'a',
				'attachment.maxSize': 'Maximální povolená velikost souboru je 20 MB, maximální povolená velikost všech souborů dohromady je 100 MB.',
				'attachment.fileTypeIsNotAllowed': 'Tento typ souboru není povolený. Povoleny jsou obrázky (.jpg, .gif, .png, .heic, .heif), dokumenty PDF, videa a zvuk v MP3.',
				'attachment.offline': 'Soubor se nepodařilo nahrát. Zkontrolujte své připojení k internetu a zkuste to znovu.',
				'attachment.errorWhileUploading': 'Chyba při nahrávání souboru. Maximální povolená velikost je 50 MB a povoleny jsou obrázky (.jpg, .gif, .png), dokumenty PDF, videa a zvuk v MP3.',
				'howCanHelp': 'Jak vám můžeme pomoci? Na co se našich lékařů chcete zeptat?',
				'additionalInfo': 'Doplňující informace. Užívané léky, absolvovaná vyšetření, výška, váha, další onemocnění',
				'question': 'Co vás trápí? Jak se potíže projevují a jak dlouho trvají.',
				'questionIsAlreadyPaid': 'Dotaz byl již zaplacen.'
			}
		},
		'en': {
			'ulekare.web.form': {
				'validation': {
					'question': {
						'missing': 'symptoms description',
						'notBlank': 'This field cannot be empty'
					},
					'problem' : {
						'missing': 'medical appointment request',
						'notBlank': 'This field cannot be empty'
					},
					'firstName' : {
						'missing': 'first name',
						'notBlank': 'Enter your first name'
					},
					'lastName' : {
						'missing': 'surname',
						'notBlank': 'Enter your surname'
					},
					'email' : {
						'missing': 'email address',
						'notBlank': 'Enter your email address so our doctors can get in touch',
						'email': 'Invalid email address'
					},
					'birthYear' : {
						'missing': 'birth year',
						'notBlank': 'Enter the patient´s birth year',
						'regexp': 'Please use 4-digit format',
						'range': 'Invalid birth year.'
					},
					'phone' : {
						'missing': 'phone number',
						'notBlank': 'Enter your phone number so our nurses can get in touch',
						'regexp': 'Enter your phone number in the correct format (+420 123456789).',
						'phoneNumber': 'Enter your phone number in the correct format (+420 123456789).'
					},
					'zipCode' : {
						'missing': 'ZIP code',
						'notBlank': 'Enter your ZIP code so we can find you a doctor',
						'regexp': 'Invalid ZIP code'
					},
					'personalDataAgreement' : {
						'missing': 'data processing agreement',
						'true': 'Personal data processing agreement is missing'
					},
					'employeeEmail' : {
						'email': 'Invalid email address',
						'invalid': 'Invalid email address',
						'benefitBlocked': 'Your employee benefit entitlement expired. Contact your HR please.',
						'sameAsPersonal': 'Use your employee email'
					},
					'benefitCode' : {
						'regexp': 'Invalid verification code',
						'useCompanyEmail': 'Verification code expired, please enter your company email address.',
						'length': 'Enter your 6-digit verification code'
					}
				},
				'loadingMessage': 'Loading...',
				'missing.and': 'and',
				'attachment.fileTypeIsNotAllowed': 'This file type is not supported',
				'attachment.errorWhileUploading': 'Upload error, please try again',
				'howCanHelp': 'How can we help? Ask our doctors about anything.',
				'additionalInfo': 'Are you taking any medication? Have you seen a doctor already? Is there anything else our doctors should know - your weight, height, any other conditions?',
				'question': 'What brings you here today? Describe your symptoms and how long they have been happening.',
				'questionIsAlreadyPaid': 'You have already paid for your request.'
			}
		}
	};

	var T = function(){
	};

	T.prototype = {
		'translate': function(identifier) {
			return translations[C.locale]['ulekare.web.form'][identifier];
		},
		'translateValidation': function(validationPlace, validationType) {
			return translations[C.locale]['ulekare.web.form']['validation'][validationPlace][validationType];
		},
	};

	return new T();
});
